import { getItem, removeItem, setItem } from '../../../utils/localStorage';
import { IFeatureFlagResponse, IUserContext } from '../interfaces/featureFlags';

const setFeatureFlags = (featureFlags: IFeatureFlagResponse) => {
  if (featureFlags.flags) {
    setItem('featureFlags', featureFlags.flags);
  }
};

const setUserContext = (userContext: IUserContext) => {
  if (userContext) {
    setItem('userContext', userContext);
  }
};

const getFeatureFlags = () => {
  return getItem('featureFlags');
};

const getFeatureFlagByKey = (featureFlagKey: string) => {
  const featureFlags = getFeatureFlags();
  return featureFlags[featureFlagKey];
};

const getUserContext = () => {
  return getItem('userContext');
};

const clearFeatureFlagsAndUserContext = () => {
  removeItem('featureFlags');
  removeItem('userContext');
};

export const featureFlagsHelpers = {
  setFeatureFlags,
  setUserContext,
  getFeatureFlags,
  getFeatureFlagByKey,
  getUserContext,
  clearFeatureFlagsAndUserContext,
};
